












































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import { PlaybookDataExecutionStatusHelper } from "../data/model";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  components: {
    AppTableRow,
  },
  props: ["source"],
  setup(props) {
    const onAction = () => {
      EventBus.emit("change-status", props.source);
    };
    const showMenu = (event: MouseEvent) => {
      EventBus.emit("showMenu", { instance: props.source, event });
    };

    const generate_script = () => {
      EventBus.emit("generate_script", props.source);
    };

    const readable_status = computed(() =>
      // @ts-ignore
      PlaybookDataExecutionStatusHelper.to_readable_status(props.source.status)
    );

    return {
      onAction,
      showMenu,
      generate_script,
      readable_status,
    };
  },
});
